import { render } from "./ConnectWalletButton.vue?vue&type=template&id=7cfb6ccd"
import script from "./ConnectWalletButton.vue?vue&type=script&lang=js"
export * from "./ConnectWalletButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/josue/Documents/projects/wwv/dapp/werewolfvalley/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__